import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IBusinessSFilter } from 'src/@types/SearchFilterTypes';
import LoadingAPI from 'src/components/LoadingAPI';
import { useStores } from 'src/models';

import { Page } from '../../../../components/Page';

import { BusinessGrid } from './BusinessGrid';
import SearchForm from './SearchForm';

/** * ## Business 설명
 * 컨텐츠 중 진행하는 사업에 대한 정보를 관리하는 화면
 */

export const Business = observer(() => {
  const { categoryStore } = useStores();
  const [isLoading, setIsLoading] = useState(true);
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<IBusinessSFilter>>({});
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setIsLoading(true);
        await categoryStore.getCategoryTree();
      } catch (error) {
        console.error('Failed to fetch categories:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, [categoryStore]);

  // 목록 검색
  const onSearch = (data: IBusinessSFilter) => {
    setSearchData(data);
  };

  if (isLoading) {
    return <LoadingAPI />;
  }

  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <BusinessGrid searchData={searchData} />
    </Page>
  );
});
export default Business;
